/* WowSticker — sticker wall review filters */
(function(){
  var wall = document.querySelector('[data-wall]');
  if(!wall) return;
  var chips = document.querySelectorAll('.sw-chip');
  var cards = wall.querySelectorAll('.sw-card');

  chips.forEach(function(chip){
    chip.addEventListener('click', function(){
      chips.forEach(function(c){ c.classList.remove('is-active'); });
      chip.classList.add('is-active');
      var f = chip.getAttribute('data-filter');
      cards.forEach(function(card){
        var cats = (card.getAttribute('data-cat') || '').split(/\s+/);
        var show = (f === 'all') || cats.indexOf(f) !== -1;
        card.hidden = !show;
      });
      // reset carousel scroll on mobile
      if(wall.scrollLeft) wall.scrollLeft = 0;
    });
  });
})();
